import React, { useEffect, useRef } from "react";
import "../../styles/DisabledOverlay.css";

const DisabledOverlay = ({ message, onLogout, onSwitchCompany }) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const el = dialogRef.current;
    if (el) {
      try {
        el.focus();
      } catch (e) {}
    }

    const handleKey = (e) => {
      if (e.key === "Escape" || e.key === "Esc") {
        e.preventDefault();
        if (onLogout) onLogout();
      }

      if (e.key === "Tab") {
        const focusable = el.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (focusable.length === 0) {
          e.preventDefault();
          return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (
            document.activeElement === first ||
            document.activeElement === el
          ) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    };

    window.addEventListener("keydown", handleKey);
    return () => {
      window.removeEventListener("keydown", handleKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onLogout]);

  return (
    <div
      className="disabled-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="disabled-overlay-title"
      aria-describedby="disabled-overlay-desc"
    >
      <div className="disabled-overlay-backdrop">
        <div className="disabled-overlay-content" ref={dialogRef} tabIndex={-1}>
          <div className="disabled-overlay-spinner">
            <div className="spinner-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <div id="disabled-overlay-title" className="disabled-overlay-message">
            {message ||
              "Your subscription has expired. All features are temporarily disabled."}
          </div>
          <div
            id="disabled-overlay-desc"
            className="disabled-overlay-submessage"
          >
            Please check your subscription status or contact support.
          </div>
          {onLogout && (
            <div className="disabled-overlay-actions">
              {onSwitchCompany && (
                <button
                  className="disabled-overlay-switch-btn"
                  onClick={onSwitchCompany}
                  type="button"
                  aria-label="Switch company"
                >
                  Switch company
                </button>
              )}
              <button
                className="disabled-overlay-logout-btn"
                onClick={onLogout}
                type="button"
                aria-label="Logout from application"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m9 21h-5a2 2 0 0 1 -2-2v-14a2 2 0 0 1 2-2h5"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <polyline
                    d="m16 17 5-5-5-5"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <line
                    x1="21"
                    y1="12"
                    x2="9"
                    y2="12"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DisabledOverlay;
